import { Typography } from '@mui/material';
import type { FC } from 'react';

export interface EmptyMessageProps {
  message?: string;
}

const EmptyMessage: FC<EmptyMessageProps> = ({ message = 'Пусто' }) => (
  <Typography
    variant='subtitle1'
    py={4}
    color='textSecondary'
    align='center'
    component={'div'}>
    {message}
  </Typography>
);

export default EmptyMessage;
